import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import PlanOption from '../../components/planOption/regular';
import {
	Defaults as PlanOptionDefaults,
	Localizations as PlanOptionLocalizations,
} from '../../components/planOption/types';

import styled from 'styled-components';
import { appStore } from '@store';
import { PaywallLayout } from '../paywallLayouts';
import { PAYWALL_LAYOUT_VERSION } from '../paywallLayouts/types';

const Container = styled.div`
	padding: 20px 20px 0;
`;

const Title = styled.h2`
	margin-bottom: 20px;
	font-weight: bold;
	font-size: 24px;
	line-height: 28px;
`;
export interface Localizations extends PlanOptionLocalizations {
	title: string;
}

export interface MailSingleProps {
	productID: string;
	defaults: PlanOptionDefaults;
	localizations: Localizations;
}

const MailSingleLayout: FC<MailSingleProps> = observer(({ productID, defaults, localizations }) => {
	const { paymentStore } = appStore;
	const { currencyType, safetyAssurance } = paymentStore.settings;

	useEffect(() => {
		paymentStore.setPaymentProductAction(productID);
	});

	const planSection = () => {
		return (
			<Container>
				<Title>{localizations.title}</Title>
				<PlanOption
					isSelected={false}
					isRadio={false}
					isPrompted={false}
					currencyType={currencyType}
					productID={productID}
					defaults={defaults}
					localizations={localizations}
				/>
			</Container>
		);
	};

	return (
		<PaywallLayout version={PAYWALL_LAYOUT_VERSION.MAIL_SINGLE}>{planSection()}</PaywallLayout>
	);
});

export default MailSingleLayout;
